import { render, staticRenderFns } from "./DAGEdge.vue?vue&type=template&id=ff2269bc&"
import script from "./DAGEdge.vue?vue&type=script&lang=ts&"
export * from "./DAGEdge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports